import DocumentItemMenu from './DocumentItemMenu';

export default DocumentItemMenu;
